import React, { Component } from "react";
import Slider from "react-slick";
import {
    Card,
    CardText,
    CardBody,
    CardTitle,
} from 'reactstrap'
export default class JourneySlider extends Component {
    render() {
        var settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 4,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        return (
            <div>
                <Slider {...settings}>
                    <div>
                        <Card>
                            <CardBody>
                                <img width="10%" src="/img/ico_flag_blue.png" alt="Card image cap" />
                                <CardTitle>We Know Tech and Startups</CardTitle>
                                <CardText>Tyler is a partner at <a href="https://e2gens.com/">E2 Generations</a>, a consulting firm that’s been building software products and assisting startups with fundraising efforts for the last eight years. </CardText>
                            </CardBody>
                        </Card>
                    </div>
                    <div>
                        <Card>
                            <CardBody>
                                <img width="10%" src="/img/ico_flag_yelow.png" alt="Card image cap" />
                                <CardTitle>C-Suite Interview Experts</CardTitle>
                                <CardText>Charlie launched <a href="https://www.charlienyc.com/leaderslive">Leaders Live</a>, the first LinkedIn live stream show, where he interviews top executives and investors across various industries to get their insights on business and leadership.</CardText>
                            </CardBody>
                        </Card>
                    </div>
                    <div>
                        <Card>
                            <CardBody>
                                <img width="10%" src="/img/ico_flag_green.png" alt="Card image cap" />
                                <CardTitle>Video and Production Excellence</CardTitle>
                                <CardText>Nidal Harvey is Head of Video Production at <a href="https://www.connectiveprod.com/">Connective</a>. He specializes in short to medium live streams productions. He also is the Production Director for <a href="https://www.charlienyc.com/leaderslive">Leaders Live</a>, one of the longest running live streaming shows on LinkedIn.</CardText>
                            </CardBody>
                        </Card>
                    </div>
                    <div>
                        <Card>
                            <CardBody>
                                <img width="10%" src="/img/ico_flag_green.png" alt="Card image cap" />
                                <CardTitle>Event Specialists</CardTitle>
                                <CardText>Tyler founded <a href="https://pitchmadness.com/">Pitch Madness</a>, a company that organizes in-person and online startup tournaments, where founders debate best practices and business scenarios for scaling their companies. The team has vetted over 1,000 startup founders to date and have organized events in three continents.</CardText>
                            </CardBody>
                        </Card>
                    </div>
                    <div>
                        <Card>
                            <CardBody>
                                <img width="10%" src="/img/ico_flag_pruple.png" alt="Card image cap" />
                                <CardTitle>Successful Pilot</CardTitle>
                                <CardText>We attracted some of the top venture capitalists in the game for our first episode - including <a href="https://twitter.com/bullpencap">Paul Martino @Bullpen Capital</a>, <a href="https://twitter.com/EniacVC">Nihal Mehta @ENIAC Ventures</a>, <a href="https://twitter.com/plexocapital"> Lo Toney @Plexo Capital</a>, and <a href="https://twitter.com/supernodevc">Jenny Friedman @Supernode Ventures</a>
                                </CardText>
                            </CardBody>
                        </Card>
                    </div>
                    <div>
                        <Card>
                            <CardBody>
                                <img width="10%" src="/img/ico_flag_blue.png" alt="Card image cap" />
                                <CardTitle>The Press & Traction</CardTitle>
                                <CardText>We were featured in <a href="https://techcrunch.com/2020/09/23/primetime-vc-venture-capitalists-are-going-on-a-gameshow-of-accredited-banter/?tpcc=ECTW2020">TechCrunch
                                </a> and have seen over 50,000 views of our content across all platforms. We have some of the best talent in venture joining our program. We now support all Podcast platforms!</CardText>
                            </CardBody>
                        </Card>
                    </div>
                    <div>
                        <Card>
                            <CardBody>
                                <img width="10%" src="/img/ico_flag_green.png" alt="Card image cap" />
                                <CardTitle>Plans moving forward</CardTitle>
                                <CardText>For the rest of 2020 our team will be releasing new episodes every two weeks. Going into 2021 we want to secure two major sponsors so that we can build up the editing team and release episodes weekly.</CardText>
                            </CardBody>
                        </Card>
                    </div>
                </Slider>
            </div>
        );
    }
}